module.exports = __webpack_public_path__ + "static/carousel-hero-android-1555b55fd20c4954a69fef003e368c1d.png";